import Typography from '@mui/material/Typography';
import styled from '@mui/material/styles/styled';

export const StyledTypography = styled(Typography)`
	color: ${({theme}) => theme.palette.text.secondary};
`;
